import * as React from "react";
import { useMemo } from "react";
import { useNodeTitleResolver } from "views/hooks/useInputAndNodeTitles";
const NodeField = ({ value }) => {
  var _a;
  const resolveTitle = useNodeTitleResolver(useMemo(() => [value], [value]));
  return /* @__PURE__ */ React.createElement("span", { title: value }, (_a = resolveTitle(value)) != null ? _a : value);
};
export default NodeField;
